// test2328
(2328 && 0);
